import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import usePageMeta from "@/hooks/use-page-meta";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/constants/content";

export default function ServicesListPage() {
  usePageMeta("Home Healthcare Services in Delhi NCR — KinFlex", "14 home healthcare services in Delhi NCR — nursing, ICU setup, physiotherapy, elder care, catheterization, IV, injections & more.");
  return (
    <Layout>
      <section className="pt-32 pb-12 md:pt-40 md:pb-16 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <div className="eyebrow mb-4">Our Services</div>
          <h1 className="font-display font-bold text-slate-900 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            14 home healthcare services, <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">delivered at your door</span>.
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
            From critical ICU nursing to physiotherapy and elder care — one team, one call, complete home healthcare.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container-page grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || Icons.Heart;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group rounded-2xl border border-slate-200/70 bg-white p-6 hover:border-[#0A84FF]/30 hover:shadow-xl hover:-translate-y-1 transition-all"
                data-testid={`services-list-${s.slug}`}
              >
                <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#0A84FF]/10 to-[#10B981]/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <Icon className="h-5 w-5" style={{ color: '#0A84FF' }} />
                </div>
                <h3 className="font-display font-semibold text-slate-900 text-lg">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.short}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A84FF] group-hover:gap-2.5 transition-all">
                  Learn more <ArrowUpRight className="h-4 w-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </Layout>
  );
}
